import { IsoDateTimeSchema, UuidSchema } from '@cookspace-shared-contracts/core';
import { z } from 'zod';

/**
 * Локальные Zod-схемы для admin-эндпоинта /audit-log.
 * Admin-only DTO в shared-contracts не выносятся; admin SPA повторяет
 * форму здесь для строгого парсинга через safeParse.
 */

export const AuditLogAdminSchema = z.object({
    id: UuidSchema,
    email: z.string()
});

export type AuditLogAdmin = z.infer<typeof AuditLogAdminSchema>;

export const AuditLogItemSchema = z.object({
    id: UuidSchema,
    adminId: UuidSchema,
    admin: AuditLogAdminSchema.nullable(),
    action: z.string(),
    targetType: z.string().nullable(),
    targetId: z.string().nullable(),
    payload: z.record(z.string(), z.unknown()).nullable(),
    ipAddress: z.string().nullable(),
    userAgent: z.string().nullable(),
    createdAt: IsoDateTimeSchema
});

export type AuditLogItem = z.infer<typeof AuditLogItemSchema>;

export const ListAuditLogResponseSchema = z.object({
    items: z.array(AuditLogItemSchema),
    total: z.number().int(),
    limit: z.number().int(),
    offset: z.number().int()
});

export type ListAuditLogResponse = z.infer<typeof ListAuditLogResponseSchema>;

export const ListAuditLogFiltersSchema = z.object({
    adminId: UuidSchema.optional(),
    action: z.string().optional(),
    targetType: z.string().optional(),
    dateFrom: IsoDateTimeSchema.optional(),
    dateTo: IsoDateTimeSchema.optional(),
    limit: z.number().int().min(1).max(100).optional(),
    offset: z.number().int().min(0).optional()
});

export type ListAuditLogFilters = z.infer<typeof ListAuditLogFiltersSchema>;
